"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/builtin/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _RootRef.default;
  }
});

var _RootRef = _interopRequireDefault(require("./RootRef"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/RootRef/index.js
// module id = 231
// module chunks = 2